// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as StaticImage from "../../../StaticImage.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.media("(min-width: 1440px)", {
            hd: BsCss.width(BsCss.pct(30.0)),
            tl: /* [] */0
          }),
      tl: {
        hd: BsCss.media("(min-width: 768px) and (max-width: 1439px)", {
              hd: BsCss.width(BsCss.pct(40.0)),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var img = Curry._1(BsCss.style, {
      hd: BsCss.display("inlineBlock"),
      tl: /* [] */0
    });

var Styles = {
  container: container,
  img: img
};

function TeamPhoto(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(StaticImage.make, {
                    src: "/images/about/value/team.png",
                    alt: "team photo",
                    width: 799,
                    height: 863,
                    className: img
                  }),
              className: container
            });
}

var Img;

var make = TeamPhoto;

export {
  Img ,
  Styles ,
  make ,
}
/* container Not a pure module */
